import { Step } from "react-joyride";

export const getRoutinesTourSteps = (): Step[] => [
  {
    target: 'h1',
    content: 'Bienvenido a tu sección de rutinas. Aquí podrás gestionar tus entrenamientos personalizados.',
    placement: 'bottom',
  },
  {
    target: '.space-y-6',
    content: 'En esta sección encontrarás tus planes de entrenamiento personales.',
    placement: 'bottom',
  },
  {
    target: '.search-routines',
    content: 'Busca y descubre nuevas rutinas creadas por profesionales.',
    placement: 'left',
  },
  {
    target: '.createplanbt',
    content: 'Crea una nueva rutina personalizada haciendo clic aquí.',
    placement: 'right',
  },
  {
    target: '.space-y-6',
    content: 'Explora y gestiona tus planes de entrenamiento publicados.',
    placement: 'top',
  }
];